import React, { Component } from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { withRouter } from "react-router-dom";

import { selectSearchResult } from "./../../selectors.js";

import "./style.css";

// An element of the filtering on the search page
class FilterOptionItem extends Component {
    onSelect(value, key, exists, type, radio) {
        this.props.history.push("/sok");
        this.props.select(value, key, exists, type, radio);
    }

    render() {
        const { data, exists, type, searchResult } = this.props;
        if (searchResult.result) {
            if (!searchResult.result) return null;
        }
        // TODO: Update the logic with new API

        // let amount = data.count;
        // if (searchResult.result) {
        // const resultType = type === "County" ? "filter_fylke"
        //     : type === "Era" ? "filter_epoke"
        //         : type === "Construction" ? "filter_hovedmateriale"
        //             : type === "ProtectionStatus" ? "filter_vernestatus"
        //                 : ""
        // const items = searchResult.result[resultType][type]
        // if (items !== undefined) {
        //     const currentResult = items.find(item => item.value === data.value)
        //     amount = currentResult ? currentResult.count : 0
        // }
        // }

        const selectClass = exists
            ? "filter-option-item--selected"
            : "filter-option-item--not-selected";
        // Determens if it should act like a radiobutton or checkbox (true = radio)
        const radio = type === "Era" ? true : false;

        const onEnter = (e) =>
            e.keyCode === 13 &&
            this.onSelect(data.value, data.key, !exists, type, radio);

        return (
            <div
                className={`filter-option-item ${selectClass}`}
                tabIndex="0"
                onKeyDown={onEnter}
                onClick={() =>
                    this.onSelect(data.value, data.key, !exists, type, radio)
                }
            >
                <div
                    className={`filter-option-item__check-wrapper ${
                        radio ? "filter-option-item__check-wrapper--radio" : ""
                    }`}
                />
                <div className="filter-option-item__item-wrapper">
                    {data.value}
                    {/* TODO: Update the logic in  */}
                    {/* <span className="filter-option-item__item-amount">({ amount })</span> */}
                </div>
            </div>
        );
    }
}

const mapStateToProps = createStructuredSelector({
    searchResult: selectSearchResult(),
});

export default withRouter(connect(mapStateToProps)(FilterOptionItem));



// WEBPACK FOOTER //
// ./src/components/FilterOptionItem/index.js